import clsx from 'clsx';
import React from 'react';
import { ProductStatus } from '../../../../types/Products/product';

export const Tag = ({ status }: { status: ProductStatus }) => {
  const tagStyle = clsx(
    'absolute block h-fit -top-1 tracking-tight -left-1 font-medium rounded-sm shadow-sm z-[1] px-2.5 py-1',
    status == 'on sale' && 'bg-[rgba(48,191,38,1)] text-white',
    status == 'low stock' && 'bg-[rgba(245,198,21,1)] text-text-dark-high',
    status == 'out of stock' && 'bg-gray-400 text-white'
  );

  return (
    <span className={tagStyle}>
      <p className="capitalize">{status}</p>
    </span>
  );
};
